/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appSorting',
})
export class SortingPipe implements PipeTransform {
  transform(value: unknown, ..._args: unknown[]): any[] {
    if (Array.isArray(value)) {
      return [...value].sort((a, b) => {
        const strA = String(a).toLowerCase();
        const strB = String(b).toLowerCase();
        return strA.localeCompare(strB);
      });
    }

    // Si no es un array, devolvemos un array vacío
    return [];
  }
}
